import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ScheduleConfigService } from '@/openapi';
import type { HolidayWithShifts } from '@/pages/scheduleConfig/Holidays';
import { queryKeys } from '@/util/queryKeys';

export const useUpdateHolidayMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (holiday: HolidayWithShifts) => {
      const holidayOnly = {
        ...holiday,
        shifts: undefined,
      };
      await ScheduleConfigService.scheduleConfigServiceUpdateHoliday({
        path: {
          id: holidayOnly.id,
        },
        body: holidayOnly,
      });
      if (holiday.shifts) {
        await ScheduleConfigService.scheduleConfigServiceUpdateHolidayShifts({
          path: {
            id: holiday.id,
          },
          body: {
            shifts: holiday.shifts.map((shift) => ({
              shiftId: shift.shiftId,
              points: shift.points,
            })),
          },
        });
      }
      return holiday;
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.holidays.list() }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.holidays.withShifts(),
        }),
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
      ]);
    },
  });
};
